import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

let blogsSwiperWr = document.querySelectorAll('.blogs-swiper-wr');
blogsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    let breakpoints = {
      552: {
        spaceBetween: 20,
        slidesPerView: 2,
      },
      768: {
        spaceBetween: 16,
        slidesPerView: 3,
      },
      1200: {
        spaceBetween: 20,
        slidesPerView: 3,
      },
    }

    if(el.classList.contains('case-studies-swiper-wr')) {
      breakpoints = {
        552: {
          spaceBetween: 20,
          slidesPerView: 1,
        },
        768: {
          spaceBetween: 16,
          slidesPerView: 1.2,
        },
        1024: {
          spaceBetween: 16,
          slidesPerView: 2,
        },
        1200: {
          spaceBetween: 20,
          slidesPerView: 2,
        },
      }
    }

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 16,
      slidesPerView: 1,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: breakpoints,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      on: {
        afterInit: function () {
          wrapper.scrollWidth >= wrapper.clientWidth
            ? wrapper.classList.remove('justify-center')
            : wrapper.classList.add('justify-center');
        },

        resize: function () {
          wrapper.scrollWidth >= wrapper.clientWidth
            ? wrapper.classList.remove('justify-center')
            : wrapper.classList.add('justify-center');
        },
      },
    });
    swiperObserver(swiper);
  }
});
